import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer implements UrlSerializer {
  private defaultUrlSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

  public parse(url: string): UrlTree {
    url = decodeURIComponent(url);
    return this.defaultUrlSerializer.parse(url);
  }

  public serialize(tree: UrlTree): string {
    return this.defaultUrlSerializer.serialize(tree);
  }
}